import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  FileUpload: any;
  Json: any;
};

export type AccLevel = {
  __typename?: 'AccLevel';
  id?: Maybe<Scalars['ID']>;
  /** E.g. standard, comfort. */
  internalKey?: Maybe<Scalars['String']>;
  /** Translated value e.g. Standard Accommodation, Comfort Accommodation. */
  name?: Maybe<Scalars['String']>;
  /** Translated value e.g. Standard, Comfort. */
  shortName?: Maybe<Scalars['String']>;
};

export type AgeRange = {
  __typename?: 'AgeRange';
  id?: Maybe<Scalars['ID']>;
  /** E.g. 24 years or below, 65 years or above. */
  internalKey?: Maybe<Scalars['String']>;
  /** Translated value e.g. 24 years or below, 65 years or above. */
  name?: Maybe<Scalars['String']>;
};

export type Agency = {
  __typename?: 'Agency';
  brandName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOptedInForFlexTerms?: Maybe<Scalars['Boolean']>;
  shortPaymentInfoForDirectPaymentsAsArray?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Agent = {
  __typename?: 'Agent';
  agency?: Maybe<Agency>;
  avgRating?: Maybe<Scalars['Float']>;
  countryNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  isAgencyOptedInForFlexTerms?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  mainCountry?: Maybe<Country>;
  noOfPublishedReviews?: Maybe<Scalars['Int']>;
  profilePageHeaderPhoto?: Maybe<Photo>;
  profilePath?: Maybe<Scalars['String']>;
  publicName?: Maybe<Scalars['String']>;
  requestFormPath?: Maybe<Scalars['String']>;
  skypeAccount?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  trips?: Maybe<Array<Maybe<Trip>>>;
  user?: Maybe<User>;
};

export type BrandAwarenessSource = {
  __typename?: 'BrandAwarenessSource';
  id?: Maybe<Scalars['ID']>;
  /** Translated value e.g. Travelled with TravelLocal before, Television. */
  name?: Maybe<Scalars['String']>;
};

export type BreadcrumbElement = {
  __typename?: 'BreadcrumbElement';
  label?: Maybe<Scalars['String']>;
  shortLabel?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ButtonsBarConfigResult = {
  __typename?: 'ButtonsBarConfigResult';
  displayNextStep: Scalars['Boolean'];
  displayPreviousStep: Scalars['Boolean'];
  nextStepIcon?: Maybe<Scalars['String']>;
  nextStepLabel?: Maybe<Scalars['String']>;
  previousStepIcon?: Maybe<Scalars['String']>;
  previousStepLabel?: Maybe<Scalars['String']>;
};

export type CheckboxInputConfigResult = {
  __typename?: 'CheckboxInputConfigResult';
  isRequired: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  id: Scalars['ID'];
  user?: Maybe<User>;
};

export type CmsPageNavigation = {
  __typename?: 'CmsPageNavigation';
  activePage?: Maybe<Page>;
  pages?: Maybe<Array<Maybe<Page>>>;
};

export type CommunityUser = {
  __typename?: 'CommunityUser';
  description?: Maybe<Scalars['String']>;
  favoriteDestination?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  originalRequestUri?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  travelPreferences?: Maybe<Scalars['String']>;
  user: User;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContentBox = {
  __typename?: 'ContentBox';
  content?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  photo?: Maybe<Photo>;
  shortHeadlineSlug?: Maybe<Scalars['String']>;
  smallPhoto?: Maybe<Photo>;
};

export type Continent = {
  __typename?: 'Continent';
  /** E.g. AF, NA. */
  code: Scalars['String'];
  countries?: Maybe<Array<Maybe<Country>>>;
  countriesWithPublishedTrips?: Maybe<Array<Maybe<Country>>>;
  id: Scalars['ID'];
  internalKey: Scalars['String'];
  /** Translated value e.g. Africa, North America. */
  name: Scalars['String'];
};

export type CounterInputConfigResult = {
  __typename?: 'CounterInputConfigResult';
  defaultValue: Scalars['Int'];
  description: Scalars['String'];
  maxValue: Scalars['Int'];
  minValue: Scalars['Int'];
  title: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  /** International call prefix e.g. +93, +32 */
  callPrefix?: Maybe<Scalars['String']>;
  clpHeaderPhoto?: Maybe<Photo>;
  /** E.g. AF, BE. */
  code: Scalars['String'];
  continent?: Maybe<Continent>;
  countryProfileForRequestLocale?: Maybe<CountryProfile>;
  id: Scalars['ID'];
  internalKey: Scalars['String'];
  /** Clp stands for country landing page. */
  linkToClp?: Maybe<Scalars['String']>;
  /** Translated value e.g. Afghanistan, Belgium. */
  name: Scalars['String'];
  photos?: Maybe<Array<Maybe<Photo>>>;
  slug: Scalars['String'];
  tripBookingTrustpilotReviewSummaryForCountry?: Maybe<Array<Maybe<LocaleTrustpilotReviewSummary>>>;
};

export type CountryProfile = {
  __typename?: 'CountryProfile';
  id: Scalars['ID'];
  publishedAgents?: Maybe<Array<Maybe<Agent>>>;
};

export type CountryRegion = {
  __typename?: 'CountryRegion';
  country?: Maybe<Country>;
  id: Scalars['ID'];
  /** Unique slug e.g. eastern-bhutan, pacific-coast. */
  internalKey?: Maybe<Scalars['String']>;
  /** Is it explicitly recommended by us when travelling to this country */
  isRecommended?: Maybe<Scalars['Boolean']>;
  /** Translated value e.g. Eastern Bhutan, Pacific Coast. */
  name?: Maybe<Scalars['String']>;
};

export type CreateOrUpdateInternalTripRequestMessageInput = {
  contentPlain?: InputMaybe<Scalars['String']>;
};

/** Object that contain request data selected by customer. */
export type CreateOrUpdateRequestConfigurationInput = {
  /** Ids can be retrieved from TripRequestForm->accLevelChoiceGroup e.g. using getTripRequestFormFromUrl query. */
  accLevels?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Id can be retrieved from TripRequestForm->ageRanges e.g. using getTripRequestFormFromUrl query. */
  ageRange?: InputMaybe<Scalars['ID']>;
  /** Date passed by customer when completing trip request form. */
  approximateArrivalDate?: InputMaybe<Scalars['DateTime']>;
  /** Average travel days number. Value can be retrieved from RequestConfiguration->minimumTravelDays. */
  averageTravelDays?: InputMaybe<Scalars['Int']>;
  /** Id can be retrieved from TripRequestForm->brandAwarenessSources e.g. using getTripRequestFormFromUrl query. */
  brandAwarenessSource?: InputMaybe<Scalars['ID']>;
  /** Ids can be retrieved from TripRequestForm->countryRegionChoiceGroup e.g. using getTripRequestFormFromUrl query. */
  countryRegions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  countryRegionsComment?: InputMaybe<Scalars['String']>;
  /** DEPRECATED! */
  flightOfferRequestComment?: InputMaybe<Scalars['String']>;
  groupTypeComment?: InputMaybe<Scalars['String']>;
  /** Trip length in days. Min allowed value can be retrieved from RequestConfiguration->minimumTravelDays  e.g. using getTripRequestFormFromUrl query. Currently max value is hardcoded to 28. */
  idealLength?: InputMaybe<Scalars['Int']>;
  isCustomerIntentPageConfirmed?: InputMaybe<Scalars['Boolean']>;
  /** Value can be retrieved from RequestConfiguration->minPlanningTimeToDepartureInWeeks. */
  minPlanningTimeToDepartureInWeeks?: InputMaybe<Scalars['Int']>;
  /** Min trip length in days. */
  minimumTravelDays?: InputMaybe<Scalars['Int']>;
  /** Value passed by customer when completing trip request form. */
  numberOfAdults?: InputMaybe<Scalars['Int']>;
  /** Value passed by customer when completing trip request form. */
  numberOfChildren?: InputMaybe<Scalars['Int']>;
  /** Value passed by customer when completing trip request form. */
  numberOfInfants?: InputMaybe<Scalars['Int']>;
  /** Value can be retrieved from getPriceRangeOptions query. */
  priceRange?: InputMaybe<Scalars['Int']>;
  /** Ids can be retrieved from TripRequestForm->travelExperienceChoiceGroup e.g. using getTripRequestFormFromUrl query. */
  travelExperiences?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travelExperiencesComment?: InputMaybe<Scalars['String']>;
  /** Id can be retrieved from TripRequestForm->travelStyleChoiceGroup e.g. using getTripRequestFormFromUrl query. */
  travelStyle?: InputMaybe<Scalars['ID']>;
};

/** Object that contain user data. */
export type CreateOrUpdateRequesterInput = {
  user?: InputMaybe<CreateUserInput>;
};

/**
 * Following fields should not be updatable through GraphQL:
 *  - locale (because it's defined by the GraphQL's HTTP request's locale)
 *  - requesterCountry (it should be defined through the IP, not explicitly set)
 *  - country (because it's defined in the (original) formUrlPath)
 *  - agent (because it's defined in the (original) formUrlPath)
 *  - trip (because it's defined in the (original) formUrlPath)
 */
export type CreateOrUpdateTripRequestInput = {
  abTestVariants?: InputMaybe<Scalars['String']>;
  /** Current url path with GET params, e.g. /en/egypt/tours/amira-1/clp-detailed-request-form/start?popupDisplayed=1 */
  formUrlPath?: InputMaybe<Scalars['String']>;
  googleAnalyticsUserId?: InputMaybe<Scalars['String']>;
  /** This has been introduced August 2019 in order to see a difference in user's intention  depending on the button they click on a trip page. */
  hasBookingIntention?: InputMaybe<Scalars['Boolean']>;
  isNewsletterSubscriptionClicked?: InputMaybe<Scalars['Boolean']>;
  isTermsAndConditionsAccepted?: InputMaybe<Scalars['Boolean']>;
  marketingSessionCampaign?: InputMaybe<Scalars['String']>;
  marketingSessionFbclid?: InputMaybe<Scalars['String']>;
  marketingSessionGclid?: InputMaybe<Scalars['String']>;
  marketingSessionMedium?: InputMaybe<Scalars['String']>;
  marketingSessionMsclkid?: InputMaybe<Scalars['String']>;
  marketingSessionPPCKeyword?: InputMaybe<Scalars['String']>;
  marketingSessionSource?: InputMaybe<Scalars['String']>;
  marketingSessionUtmAdgroup?: InputMaybe<Scalars['String']>;
  /** Message left by customer when completing trip request form. */
  message?: InputMaybe<Scalars['String']>;
  requestConfiguration?: InputMaybe<CreateOrUpdateRequestConfigurationInput>;
  requester?: InputMaybe<CreateOrUpdateRequesterInput>;
  /** Id can be retrieved from TripRequest->TripRequestFormType e.g. using getTripRequestFormFromUrl query. */
  tripRequestFormType?: InputMaybe<Scalars['ID']>;
};

export type CreateTripBookingFeedbackInput = {
  client?: InputMaybe<UpdateClientInput>;
  comment?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  recommendation: Scalars['Int'];
  tripBookingId: Scalars['ID'];
  tripBookingSecurityToken: Scalars['String'];
  tripMeComment?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  calendarLink?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferredLocale?: InputMaybe<Scalars['ID']>;
};

export type Currency = {
  __typename?: 'Currency';
  /** E.g. EUR, USD. */
  abbreviation: Scalars['String'];
  id: Scalars['ID'];
  locales?: Maybe<Array<Maybe<Locale>>>;
  /** Translated value e.g. Euro, US Dollar. */
  name: Scalars['String'];
  /** E.g. €, US$. */
  symbol: Scalars['String'];
};

export type DateInputConfigResult = {
  __typename?: 'DateInputConfigResult';
  displayNullableCheckbox: Scalars['Boolean'];
  initialUnavailableWeeks: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  nullableCheckboxLabel?: Maybe<Scalars['String']>;
  placeholder: Scalars['String'];
};

export type Departure = {
  __typename?: 'Departure';
  departureStatus?: Maybe<DepartureStatus>;
  endDate?: Maybe<Scalars['DateTime']>;
  isBookable?: Maybe<Scalars['Boolean']>;
  isGuaranteed?: Maybe<Scalars['Boolean']>;
  maxPax?: Maybe<Scalars['Int']>;
  minPax?: Maybe<Scalars['Int']>;
  noOfDays?: Maybe<Scalars['Int']>;
  singleRoomSupplement?: Maybe<Scalars['Float']>;
  specificPrice?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type DepartureStatus = {
  __typename?: 'DepartureStatus';
  name?: Maybe<Scalars['String']>;
};

export type DropdownOption = {
  __typename?: 'DropdownOption';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DynamicText = {
  __typename?: 'DynamicText';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  uniqueKey: Scalars['String'];
};

export type ElementStyleConfigResult = {
  __typename?: 'ElementStyleConfigResult';
  paddingBottom?: Maybe<PaddingBottomStyleConfigResult>;
  paddingTop?: Maybe<PaddingTopStyleConfigResult>;
};

export type ExtendedPageInfo = {
  __typename?: 'ExtendedPageInfo';
  nextPages?: Maybe<Array<Maybe<PaginationEntry>>>;
  previousPages?: Maybe<Array<Maybe<PaginationEntry>>>;
};

export type FeaturedContentHero = {
  __typename?: 'FeaturedContentHero';
  buttonLabel?: Maybe<Scalars['String']>;
  buttonLink?: Maybe<Scalars['String']>;
  photo?: Maybe<Photo>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type FormStepCompletionParams = {
  completedInputs?: InputMaybe<Array<InputMaybe<FormStepInputCompletionParams>>>;
  formUuid: Scalars['String'];
  stepUuid: Scalars['String'];
};

export type FormStepCompletionResult = {
  __typename?: 'FormStepCompletionResult';
  formUuid: Scalars['String'];
  nextStepUuid?: Maybe<Scalars['String']>;
  tripRequest?: Maybe<FormTripRequestCreationResult>;
};

export type FormStepConfigParams = {
  formUuid: Scalars['String'];
  stepUuid: Scalars['String'];
};

export type FormStepConfigResult = {
  __typename?: 'FormStepConfigResult';
  currentStepNumber: Scalars['Int'];
  currentStepUuid: Scalars['String'];
  elements?: Maybe<Array<Maybe<FormStepElementConfigResult>>>;
  formUuid: Scalars['String'];
  previousStepUuid?: Maybe<Scalars['String']>;
  totalStepsNumber: Scalars['Int'];
};

export type FormStepElementConfigResult = {
  __typename?: 'FormStepElementConfigResult';
  config?: Maybe<FormStepElementConfigTypeResolver>;
  elementType: Scalars['String'];
  style?: Maybe<ElementStyleConfigResult>;
};

export type FormStepElementConfigTypeResolver = ButtonsBarConfigResult | HeaderConfigResult | InputConfigResult | LeCustomerConnectionConfigResult | LeProTipConfigResult | PriceAndServicesConfigResult | ProgressBarConfigResult | ProgressFeedbackConfigResult | TrustpilotConfigResult | WhatNextConfigResult;

export type FormStepInputCompletionParams = {
  inputJsonData: Scalars['Json'];
  inputUuid: Scalars['String'];
};

export type FormTripRequestCreationResult = {
  __typename?: 'FormTripRequestCreationResult';
  destinationCountryInternalKey: Scalars['String'];
  id: Scalars['Int'];
  originCountryName?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  user: FormUserCreationResult;
};

export type FormUserCreationResult = {
  __typename?: 'FormUserCreationResult';
  email: Scalars['String'];
  id: Scalars['Int'];
};

export type HeaderConfigResult = {
  __typename?: 'HeaderConfigResult';
  text: Scalars['String'];
  variant: Scalars['String'];
};

export type ImageChoice = {
  __typename?: 'ImageChoice';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  internalKey: Scalars['String'];
  isRecommended?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type ImageChoiceGroup = {
  __typename?: 'ImageChoiceGroup';
  imageChoices?: Maybe<Array<Maybe<ImageChoice>>>;
};

export type ImageChoiceInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl: Scalars['String'];
  internalKey: Scalars['String'];
  name: Scalars['String'];
};

export type InputConfigResult = {
  __typename?: 'InputConfigResult';
  completedJsonData?: Maybe<Scalars['Json']>;
  completionType: Scalars['String'];
  inputConfig?: Maybe<InputConfigTypeResolver>;
  inputType: Scalars['String'];
  inputUuid: Scalars['String'];
};

export type InputConfigTypeResolver = CheckboxInputConfigResult | CounterInputConfigResult | DateInputConfigResult | MultiselectInputConfigResult | SelectInputConfigResult | SliderInputConfigResult | TextInputConfigResult | TextareaInputConfigResult;

export type LandingPage = {
  __typename?: 'LandingPage';
  cachedFinalUrl?: Maybe<Scalars['String']>;
  h1?: Maybe<Scalars['String']>;
  headerPhoto?: Maybe<Photo>;
  headerPhotoImgAltText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  infoBoxes?: Maybe<Array<Maybe<LandingPageInfoBox>>>;
  infoSidebarBoxPhoto?: Maybe<Photo>;
  mainKeyword?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  relatedLpGroups?: Maybe<Array<Maybe<RelatedLandingPageGroup>>>;
  requestFormPath?: Maybe<Scalars['String']>;
  shortIntroBox?: Maybe<Scalars['String']>;
  trips?: Maybe<Array<Maybe<Trip>>>;
};

export type LandingPageInfoBox = {
  __typename?: 'LandingPageInfoBox';
  content?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  photo?: Maybe<Photo>;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String'];
  id: Scalars['ID'];
  locales?: Maybe<Array<Maybe<Locale>>>;
  name: Scalars['String'];
  nameInThisLanguage: Scalars['String'];
};

export type LanguageSwitcherPage = {
  __typename?: 'LanguageSwitcherPage';
  localeString?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type LeCustomerConnectionConfigResult = {
  __typename?: 'LeCustomerConnectionConfigResult';
  test: Scalars['String'];
};

export type LeProTipAgentImageConfigResult = {
  __typename?: 'LeProTipAgentImageConfigResult';
  imageUrl: Scalars['String'];
};

export type LeProTipConfigResult = {
  __typename?: 'LeProTipConfigResult';
  agentsImages?: Maybe<Array<Maybe<LeProTipAgentImageConfigResult>>>;
  description?: Maybe<Scalars['String']>;
  imagesPosition: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Locale = {
  __typename?: 'Locale';
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  /** E.g. de, en, en_GB. */
  name: Scalars['String'];
  primaryLanguage?: Maybe<Language>;
};

export type LocaleTrustpilotReviewSummary = {
  __typename?: 'LocaleTrustpilotReviewSummary';
  locale: Scalars['String'];
  summary: TrustpilotReviewSummary;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  currencyAbbreviation: Scalars['String'];
};

export type MultiselectInputConfigResult = {
  __typename?: 'MultiselectInputConfigResult';
  items?: Maybe<Array<Maybe<MultiselectInputItemConfigResult>>>;
};

export type MultiselectInputItemConfigResult = {
  __typename?: 'MultiselectInputItemConfigResult';
  description?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  itemId: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MutationPublic = {
  __typename?: 'MutationPublic';
  completeRequestFormStep: FormStepCompletionResult;
  createInternalTripRequestMessageByTripRequestAndSend: TripRequestMessage;
  createTripBookingFeedback: TripBookingFeedback;
  /** Used to create trip request at final step. CreateOrUpdateTripRequestInput argument object  contain data of created trip request. */
  createTripRequest: TripRequest;
  initRequestForm: RequestFormInitializationResult;
  login?: Maybe<CommunityUser>;
  registerAndVerifyByUserIdAndToken?: Maybe<CommunityUser>;
  registerByEmail?: Maybe<CommunityUser>;
  requestPasswordResetByEmail: Scalars['Boolean'];
  resetPasswordByCommunityUserIdAndToken: Scalars['Boolean'];
  updateTripRequest: TripRequest;
  verifyByCommunityUserIdAndToken?: Maybe<CommunityUser>;
};


export type MutationPublicCompleteRequestFormStepArgs = {
  params: FormStepCompletionParams;
};


export type MutationPublicCreateInternalTripRequestMessageByTripRequestAndSendArgs = {
  input: CreateOrUpdateInternalTripRequestMessageInput;
  securityToken: Scalars['String'];
  tripRequestId: Scalars['ID'];
};


export type MutationPublicCreateTripBookingFeedbackArgs = {
  tripBookingFeedback?: InputMaybe<CreateTripBookingFeedbackInput>;
};


export type MutationPublicCreateTripRequestArgs = {
  tripRequest?: InputMaybe<CreateOrUpdateTripRequestInput>;
};


export type MutationPublicInitRequestFormArgs = {
  params: RequestFormInitializationParams;
};


export type MutationPublicLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationPublicRegisterAndVerifyByUserIdAndTokenArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationPublicRegisterByEmailArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationPublicRequestPasswordResetByEmailArgs = {
  email: Scalars['String'];
};


export type MutationPublicResetPasswordByCommunityUserIdAndTokenArgs = {
  communityUserId: Scalars['ID'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationPublicUpdateTripRequestArgs = {
  securityToken: Scalars['String'];
  tripRequest?: InputMaybe<CreateOrUpdateTripRequestInput>;
  tripRequestId: Scalars['ID'];
};


export type MutationPublicVerifyByCommunityUserIdAndTokenArgs = {
  communityUserId: Scalars['ID'];
  token: Scalars['String'];
};

export type OldWpArticle = {
  __typename?: 'OldWpArticle';
  author: Scalars['String'];
  content: Scalars['String'];
  excerpt: Scalars['String'];
  headerImageUrl: Scalars['String'];
  id: Scalars['ID'];
  publishDate: Scalars['DateTime'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type PaddingBottomStyleConfigResult = {
  __typename?: 'PaddingBottomStyleConfigResult';
  value: Scalars['Int'];
};

export type PaddingTopStyleConfigResult = {
  __typename?: 'PaddingTopStyleConfigResult';
  value: Scalars['Int'];
};

export type Page = {
  __typename?: 'Page';
  callToActionLinkLabel?: Maybe<Scalars['String']>;
  callToActionLinkTarget?: Maybe<Scalars['String']>;
  cmsPageNavigation?: Maybe<CmsPageNavigation>;
  content?: Maybe<Scalars['String']>;
  contentBoxes?: Maybe<Array<Maybe<ContentBox>>>;
  description?: Maybe<Scalars['String']>;
  h1?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isContentBoxesInNavigation?: Maybe<Scalars['Boolean']>;
  isInSidebarNavigation?: Maybe<Scalars['Boolean']>;
  isReviewsBoxShown?: Maybe<Scalars['Boolean']>;
  isSidebarNavigationShown?: Maybe<Scalars['Boolean']>;
  mainPhoto?: Maybe<Photo>;
  metaDescription?: Maybe<Scalars['String']>;
  pagePath?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type PaginationEntry = {
  __typename?: 'PaginationEntry';
  cursor: Scalars['String'];
};

export type Photo = {
  __typename?: 'Photo';
  filename: Scalars['String'];
  hasTripMeCopyrights: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type PriceAndServicesConfigResult = {
  __typename?: 'PriceAndServicesConfigResult';
  numberOfTravelers: Scalars['Int'];
  priceRange: Scalars['String'];
  tripLength: Scalars['Int'];
};

export type PriceRangeChoice = {
  __typename?: 'PriceRangeChoice';
  /** E.g. US$1000-1500, US$2000-2500 where last element looks like - More than US$8500 and is translated */
  label?: Maybe<Scalars['String']>;
  /** Accordingly to the above labels we will have e.g 1000, 2000, 8500 */
  value?: Maybe<Scalars['Int']>;
};

export type PriceRangeOptions = {
  __typename?: 'PriceRangeOptions';
  /** Same as averageValueWithCurrencySymbol but int value. */
  averageValue?: Maybe<Scalars['Int']>;
  /** How much in average customer spend on trip request of this kind. Translated value specific for trip request  and calculated based on data passed by customer in previous steps. */
  averageValueWithCurrencySymbol?: Maybe<Scalars['String']>;
  /** Default value specific for trip request and calculated based on data passed by customer in previous steps. */
  defaultPriceRange?: Maybe<Scalars['Int']>;
  priceRangeChoices?: Maybe<Array<Maybe<PriceRangeChoice>>>;
};

export type ProgressBarConfigResult = {
  __typename?: 'ProgressBarConfigResult';
  completedPercentage: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
};

export type ProgressFeedbackConfigResult = {
  __typename?: 'ProgressFeedbackConfigResult';
  icon?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type QueryPublic = {
  __typename?: 'QueryPublic';
  countTripBookingFeedbacksByAgency?: Maybe<Scalars['Int']>;
  countTripBookingFeedbacksByAgent?: Maybe<Scalars['Int']>;
  createTripRequestFromUrl: TripRequest;
  describeRegisterByEmail?: Maybe<Scalars['String']>;
  doCommunityUserIdAndResetPasswordTokenMatch: Scalars['Boolean'];
  doUserIdAndTokenMatch: Scalars['Boolean'];
  getAccLevels?: Maybe<Array<Maybe<AccLevel>>>;
  getAgentByPath?: Maybe<Agent>;
  getAgentsByCountry?: Maybe<Array<Maybe<Agent>>>;
  getAgentsByCountrySlug?: Maybe<Array<Maybe<Agent>>>;
  getBlogArticles?: Maybe<Array<Maybe<OldWpArticle>>>;
  getBlogBreadcrumb?: Maybe<Array<Maybe<BreadcrumbElement>>>;
  getCmsPageBreadcrumb?: Maybe<Array<Maybe<BreadcrumbElement>>>;
  getCommunityUser: CommunityUser;
  getContactDetails?: Maybe<ContactDetails>;
  getContinentsWithPublishedTrips?: Maybe<Array<Maybe<Continent>>>;
  getCountriesWithCallPrefix?: Maybe<Array<Maybe<DropdownOption>>>;
  getCountryBySlug: Country;
  getCountryLandingPagesInNav?: Maybe<Array<Maybe<LandingPage>>>;
  getFeaturedAgents?: Maybe<Array<Maybe<Agent>>>;
  getFeaturedContentHeroes?: Maybe<Array<Maybe<FeaturedContentHero>>>;
  getFeaturedLandingPages?: Maybe<Array<Maybe<LandingPage>>>;
  getFiltersByCountrySlug?: Maybe<TripFilter>;
  getLandingPageBreadcrumb?: Maybe<Array<Maybe<BreadcrumbElement>>>;
  getLandingPageByPath?: Maybe<LandingPage>;
  getLanguageSwitcherPages?: Maybe<Array<Maybe<LanguageSwitcherPage>>>;
  getLatestTripBookingFeedbacksWithPhotoAndPublishedTripMeComment?: Maybe<Array<Maybe<TripBookingFeedback>>>;
  getPageByPath?: Maybe<Page>;
  getPathByLandingPageAndTripFilterState?: Maybe<Scalars['String']>;
  getPriceRange: Scalars['String'];
  /** Dynamically created price ranges options based on tripLength, accLevelId, countryId and tripId. */
  getPriceRangeOptions?: Maybe<PriceRangeOptions>;
  getProfilePageBreadcrumb?: Maybe<Array<Maybe<BreadcrumbElement>>>;
  getPublishedInspirationLandingPages?: Maybe<Array<Maybe<LandingPage>>>;
  getRequestFormStep: FormStepConfigResult;
  getReviewsPageBreadcrumb?: Maybe<Array<Maybe<BreadcrumbElement>>>;
  getSharedUrls?: Maybe<Scalars['Json']>;
  getTrip: Trip;
  getTripBooking?: Maybe<TripBooking>;
  getTripBookingFeedback?: Maybe<TripBookingFeedback>;
  getTripBookingFeedbackStatistics?: Maybe<TripBookingFeedbackStatistics>;
  getTripBookingFeedbacks?: Maybe<TripBookingFeedbackConnection>;
  getTripBookingFeedbacksByAgency?: Maybe<TripBookingFeedbackConnection>;
  getTripBookingFeedbacksByAgent?: Maybe<TripBookingFeedbackConnection>;
  getTripByPath?: Maybe<Trip>;
  getTripFilterAndStateAndResultByLandingPageAndPath?: Maybe<TripFilterAndStateAndResult>;
  getTripFilterByLandingPage?: Maybe<TripFilter>;
  getTripFilterResultByLandingPageAndTripFilterAndState?: Maybe<TripFilterResult>;
  getTripFilterStateByPath?: Maybe<TripFilterState>;
  getTripPageBreadcrumb?: Maybe<Array<Maybe<BreadcrumbElement>>>;
  getTripRequestByIdAndTemporaryToken: TripRequest;
  getTripRequestForm: TripRequestForm;
  /** Used to obtain all the necessary data to build trip request form, e.g. travelExperienceChoiceGroup,  accLevelChoiceGroup. Data is return based on current url. */
  getTripRequestFormFromUrl: TripRequestForm;
  getTripRequestRedirectUrlIfBadQuality?: Maybe<Scalars['String']>;
  getTripsByCountrySlugAndFilters?: Maybe<TripFilterResult>;
  getUserByIdAndToken: User;
  getWeightedTripsBySimilarityTo?: Maybe<Array<Maybe<WeightedTrip>>>;
  isEmailPotentiallyInvalid: Scalars['Boolean'];
  isLoggedIn: Scalars['Boolean'];
  populateInitialTripRequestWithSessionData: TripRequest;
  saveRequestToSession: Scalars['Boolean'];
};


export type QueryPublicCountTripBookingFeedbacksByAgencyArgs = {
  agencyId: Scalars['ID'];
  excludedAgentId?: InputMaybe<Scalars['ID']>;
};


export type QueryPublicCountTripBookingFeedbacksByAgentArgs = {
  agentId: Scalars['ID'];
};


export type QueryPublicCreateTripRequestFromUrlArgs = {
  url: Scalars['String'];
};


export type QueryPublicDoCommunityUserIdAndResetPasswordTokenMatchArgs = {
  communityUserId: Scalars['ID'];
  token: Scalars['String'];
};


export type QueryPublicDoUserIdAndTokenMatchArgs = {
  token: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryPublicGetAgentByPathArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetAgentsByCountryArgs = {
  countryId: Scalars['ID'];
};


export type QueryPublicGetAgentsByCountrySlugArgs = {
  countrySlug: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicGetBlogBreadcrumbArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPublicGetCmsPageBreadcrumbArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetCommunityUserArgs = {
  communityUserId?: InputMaybe<Scalars['ID']>;
};


export type QueryPublicGetCountryBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryPublicGetFiltersByCountrySlugArgs = {
  countrySlug: Scalars['String'];
};


export type QueryPublicGetLandingPageBreadcrumbArgs = {
  landingPageId: Scalars['ID'];
};


export type QueryPublicGetLandingPageByPathArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetLanguageSwitcherPagesArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetPageByPathArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetPathByLandingPageAndTripFilterStateArgs = {
  landingPageId: Scalars['ID'];
  tripFilterState: TripFilterStateInput;
};


export type QueryPublicGetPriceRangeArgs = {
  countrySlug: Scalars['String'];
  numberOfTravelers: Scalars['Int'];
  tripLength: Scalars['Int'];
};


export type QueryPublicGetPriceRangeOptionsArgs = {
  accLevelId: Scalars['Int'];
  countryId: Scalars['Int'];
  tripId?: InputMaybe<Scalars['Int']>;
  tripLength: Scalars['Int'];
};


export type QueryPublicGetProfilePageBreadcrumbArgs = {
  agentId: Scalars['ID'];
};


export type QueryPublicGetRequestFormStepArgs = {
  params: FormStepConfigParams;
};


export type QueryPublicGetTripArgs = {
  tripId: Scalars['ID'];
};


export type QueryPublicGetTripBookingArgs = {
  securityToken: Scalars['String'];
  tripBookingId: Scalars['ID'];
};


export type QueryPublicGetTripBookingFeedbackArgs = {
  tripBookingFeedbackId: Scalars['ID'];
};


export type QueryPublicGetTripBookingFeedbacksArgs = {
  afterCursor?: InputMaybe<Scalars['String']>;
  beforeCursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxNoOfNeighborPages?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicGetTripBookingFeedbacksByAgencyArgs = {
  afterCursor?: InputMaybe<Scalars['String']>;
  agencyId: Scalars['ID'];
  beforeCursor?: InputMaybe<Scalars['String']>;
  excludedAgentId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxNoOfNeighborPages?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicGetTripBookingFeedbacksByAgentArgs = {
  afterCursor?: InputMaybe<Scalars['String']>;
  agentId: Scalars['ID'];
  beforeCursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxNoOfNeighborPages?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicGetTripByPathArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetTripFilterAndStateAndResultByLandingPageAndPathArgs = {
  landingPageId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  path: Scalars['String'];
};


export type QueryPublicGetTripFilterByLandingPageArgs = {
  landingPageId: Scalars['ID'];
};


export type QueryPublicGetTripFilterResultByLandingPageAndTripFilterAndStateArgs = {
  landingPageId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tripFilter: TripFilterInput;
  tripFilterState: TripFilterStateInput;
};


export type QueryPublicGetTripFilterStateByPathArgs = {
  path: Scalars['String'];
};


export type QueryPublicGetTripPageBreadcrumbArgs = {
  tripId: Scalars['ID'];
};


export type QueryPublicGetTripRequestByIdAndTemporaryTokenArgs = {
  securityToken: Scalars['String'];
  tripRequestId: Scalars['ID'];
};


export type QueryPublicGetTripRequestFormArgs = {
  agentSlug?: InputMaybe<Scalars['String']>;
  countrySlug?: InputMaybe<Scalars['String']>;
  tripSlug?: InputMaybe<Scalars['String']>;
  tripType?: InputMaybe<Scalars['String']>;
};


export type QueryPublicGetTripRequestFormFromUrlArgs = {
  url: Scalars['String'];
};


export type QueryPublicGetTripRequestRedirectUrlIfBadQualityArgs = {
  tripRequest?: InputMaybe<CreateOrUpdateTripRequestInput>;
};


export type QueryPublicGetTripsByCountrySlugAndFiltersArgs = {
  countrySlug: Scalars['String'];
  filters: Scalars['Json'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicGetUserByIdAndTokenArgs = {
  token: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryPublicGetWeightedTripsBySimilarityToArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  tripId: Scalars['ID'];
  weightSameContinent?: InputMaybe<Scalars['Int']>;
  weightSameCountry?: InputMaybe<Scalars['Int']>;
  weightSameTag?: InputMaybe<Scalars['Int']>;
  weightSameTravelStyle?: InputMaybe<Scalars['Int']>;
  weightSimilarLength?: InputMaybe<Scalars['Int']>;
  weightSimilarPrice?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicIsEmailPotentiallyInvalidArgs = {
  email: Scalars['String'];
};


export type QueryPublicPopulateInitialTripRequestWithSessionDataArgs = {
  tripRequest?: InputMaybe<CreateOrUpdateTripRequestInput>;
};


export type QueryPublicSaveRequestToSessionArgs = {
  tripRequest?: InputMaybe<CreateOrUpdateTripRequestInput>;
};

export type RelatedLandingPageGroup = {
  __typename?: 'RelatedLandingPageGroup';
  headline?: Maybe<Scalars['String']>;
  lps?: Maybe<Array<Maybe<LandingPage>>>;
};

/** Object that contain request data and is in one to one relationship with trip request object. */
export type RequestConfiguration = {
  __typename?: 'RequestConfiguration';
  accLevels?: Maybe<Array<Maybe<AccLevel>>>;
  ageRange?: Maybe<AgeRange>;
  /** Date passed by customer when completing trip request form. */
  approximateArrivalDate?: Maybe<Scalars['DateTime']>;
  /** Average travel days number specific for country profile. */
  averageTravelDays?: Maybe<Scalars['Int']>;
  brandAwarenessSource?: Maybe<BrandAwarenessSource>;
  countryRegions?: Maybe<Array<Maybe<CountryRegion>>>;
  countryRegionsComment?: Maybe<Scalars['String']>;
  /** DEPRECATED! */
  flightOfferRequestComment?: Maybe<Scalars['String']>;
  groupTypeComment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Trip length in days passed by customer when completing trip request form. */
  idealLength?: Maybe<Scalars['Int']>;
  isCustomerIntentPageConfirmed?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED! */
  isFlightOfferRequested?: Maybe<Scalars['Boolean']>;
  /** First possible day to select at approximateArrivalDate should be so many weeks into the future. */
  minPlanningTimeToDepartureInWeeks?: Maybe<Scalars['Int']>;
  /** Min trip length in days. */
  minimumTravelDays?: Maybe<Scalars['Int']>;
  /** Value passed by customer when completing trip request form. */
  numberOfAdults?: Maybe<Scalars['Int']>;
  /** Value passed by customer when completing trip request form. */
  numberOfChildren?: Maybe<Scalars['Int']>;
  /** Value passed by customer when completing trip request form. */
  numberOfInfants?: Maybe<Scalars['Int']>;
  /** Value selected by customer e.g. 500, 1000, 1500. See getPriceRangeOptions query for details. */
  priceRange?: Maybe<Scalars['Int']>;
  travelExperiences?: Maybe<Array<Maybe<TravelExperience>>>;
  travelExperiencesComment?: Maybe<Scalars['String']>;
  travelStyle?: Maybe<TravelStyle>;
};

export type RequestFormAbTestingDataParams = {
  variants?: InputMaybe<Scalars['Json']>;
};

export type RequestFormInitializationParams = {
  countrySlug: Scalars['String'];
  metadata: RequestFormMetadataParams;
};

export type RequestFormInitializationResult = {
  __typename?: 'RequestFormInitializationResult';
  firstStepUuid: Scalars['String'];
  formUuid: Scalars['String'];
};

export type RequestFormMarketingDataParams = {
  adgroup?: InputMaybe<Scalars['String']>;
  campaign?: InputMaybe<Scalars['String']>;
  googleAnalyticsUserId?: InputMaybe<Scalars['String']>;
  googleClickId?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  metaClickId?: InputMaybe<Scalars['String']>;
  microsoftClickId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type RequestFormMetadataParams = {
  ABTestingData: RequestFormAbTestingDataParams;
  marketingData: RequestFormMarketingDataParams;
};

/** User created after submitting trip request form. */
export type Requester = {
  __typename?: 'Requester';
  id: Scalars['ID'];
  isInvitedToTravelerAccount?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type SelectInputConfigResult = {
  __typename?: 'SelectInputConfigResult';
  items?: Maybe<Array<Maybe<MultiselectInputItemConfigResult>>>;
};

export type SliderInputConfigResult = {
  __typename?: 'SliderInputConfigResult';
  currentValueIcon: Scalars['String'];
  currentValueLabel: Scalars['String'];
  defaultValue: Scalars['Int'];
  defaultValueLabel: Scalars['String'];
  displayNullableCheckbox: Scalars['Boolean'];
  maxValue: Scalars['Int'];
  maxValueLabel: Scalars['String'];
  minValue: Scalars['Int'];
  minValueLabel: Scalars['String'];
  nullableCheckboxLabel?: Maybe<Scalars['String']>;
};

export type TextInputConfigResult = {
  __typename?: 'TextInputConfigResult';
  isRequired: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
};

export type TextareaInputConfigResult = {
  __typename?: 'TextareaInputConfigResult';
  placeholderListItems?: Maybe<Array<Maybe<TextareaPlaceholderListInputItemConfigResult>>>;
  placeholderListTitle: Scalars['String'];
};

export type TextareaPlaceholderListInputItemConfigResult = {
  __typename?: 'TextareaPlaceholderListInputItemConfigResult';
  title: Scalars['String'];
};

export type TravelExperience = {
  __typename?: 'TravelExperience';
  id?: Maybe<Scalars['ID']>;
  /** E.g. culture, animals. */
  internalKey?: Maybe<Scalars['String']>;
  /** If it's equal to true then is returned for trip request form. */
  isRelevantForTripRequest?: Maybe<Scalars['Boolean']>;
  /** Translated value e.g. Cultural visits, Animals & wildlife. */
  name?: Maybe<Scalars['String']>;
};

export type TravelStyle = {
  __typename?: 'TravelStyle';
  /** Translated value e.g. DIY, on a budget, when possible I like to drive myself. */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Translated value e.g. Backpacker, Self-driving. */
  name?: Maybe<Scalars['String']>;
};

export type Trip = {
  __typename?: 'Trip';
  activeDepartures?: Maybe<Array<Maybe<Departure>>>;
  agent?: Maybe<Agent>;
  amountOfTripDays?: Maybe<Scalars['Int']>;
  countriesAsDashSeparatedList?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  /** List of excluded services e.g. Drinks and alcoholic beverages. */
  excludedItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  /** List of included services e.g. 10 nights accommodation in double room in 4-5 star hotel. */
  includedItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** This is used as the main country of the trip while no D.E. is assigned. */
  initialMainCountry: Country;
  /** Whether tripType is of type group. */
  isGroupTrip?: Maybe<Scalars['Boolean']>;
  /** Whether tripType is of type module. */
  isModuleTrip?: Maybe<Scalars['Boolean']>;
  /** If published within the last x days. At the time of writing it's 60 days. */
  isNewTrip?: Maybe<Scalars['Boolean']>;
  isSingleRoomSupplementProvidedForActiveDepartures?: Maybe<Scalars['Boolean']>;
  linkToOneStepRequestForm?: Maybe<Scalars['String']>;
  linkToThreeStepRequestForm?: Maybe<Scalars['String']>;
  linkToTripPage?: Maybe<Scalars['String']>;
  mainAttractions?: Maybe<Array<Maybe<Scalars['String']>>>;
  mainPhotoURL?: Maybe<Scalars['String']>;
  mainTripTag?: Maybe<TripTag>;
  /** Google map url. */
  mapUrl?: Maybe<Scalars['String']>;
  offeringAgents?: Maybe<Array<Maybe<Agent>>>;
  /** List of optional services e.g. Trekking Tour in ... (USD 35 per person). */
  optionalItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug?: Maybe<Scalars['String']>;
  startingPricePerPerson?: Maybe<Scalars['Float']>;
  sustainabilityTripTags?: Maybe<Array<Maybe<TripTag>>>;
  title?: Maybe<Scalars['String']>;
  travelStyle?: Maybe<TravelStyle>;
  tripAgentReviews?: Maybe<Array<Maybe<TripBookingFeedback>>>;
  tripDays?: Maybe<Array<Maybe<TripDay>>>;
  tripOfferingType?: Maybe<TripOfferingType>;
  /** Current trip path. */
  tripPath?: Maybe<Scalars['String']>;
  tripPrice?: Maybe<Scalars['Float']>;
  tripPriceMatrix?: Maybe<TripPriceMatrix>;
  tripTags?: Maybe<Array<Maybe<TripTag>>>;
  tripType?: Maybe<TripType>;
};

export type TripBooking = {
  __typename?: 'TripBooking';
  bookingClient?: Maybe<Client>;
  bookingName?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  finalOfferUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locale?: Maybe<Locale>;
  numberOfPassengers?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  tripPriceInClientCurrency?: Maybe<Scalars['String']>;
  tripRequest?: Maybe<TripRequest>;
};

export type TripBookingFeedback = {
  __typename?: 'TripBookingFeedback';
  agent: Agent;
  client?: Maybe<Client>;
  comment?: Maybe<Scalars['String']>;
  entryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  locale?: Maybe<Locale>;
  moderatedTripMeComment?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tripBooking?: Maybe<TripBooking>;
};

export type TripBookingFeedbackConnection = {
  __typename?: 'TripBookingFeedbackConnection';
  edges: Array<Maybe<TripBookingFeedbackEdge>>;
  pageInfo: ExtendedPageInfo;
};

export type TripBookingFeedbackEdge = {
  __typename?: 'TripBookingFeedbackEdge';
  cursor: Scalars['String'];
  node: TripBookingFeedback;
};

export type TripBookingFeedbackStatistics = {
  __typename?: 'TripBookingFeedbackStatistics';
  avgRating?: Maybe<Scalars['Float']>;
  ratingPercent?: Maybe<Array<Maybe<Scalars['Int']>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TripDay = {
  __typename?: 'TripDay';
  accDetails?: Maybe<TripDayAccDetails>;
  dashSeparatedDestinations?: Maybe<Scalars['String']>;
  dayNumber?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBreakfastIncluded?: Maybe<Scalars['Boolean']>;
  isDinnerIncluded?: Maybe<Scalars['Boolean']>;
  isLunchIncluded?: Maybe<Scalars['Boolean']>;
  photoURL?: Maybe<Scalars['String']>;
};

export type TripDayAccDetail = {
  __typename?: 'TripDayAccDetail';
  name?: Maybe<Scalars['String']>;
  photoURL?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TripDayAccDetails = {
  __typename?: 'TripDayAccDetails';
  comfort?: Maybe<TripDayAccDetail>;
  group?: Maybe<TripDayAccDetail>;
  hasAny?: Maybe<Scalars['Boolean']>;
  luxury?: Maybe<TripDayAccDetail>;
  standard?: Maybe<TripDayAccDetail>;
};

export type TripFilter = {
  __typename?: 'TripFilter';
  isShown?: Maybe<Scalars['Boolean']>;
  tripFilterElements: Array<TripFilterElement>;
};

export type TripFilterAndStateAndResult = {
  __typename?: 'TripFilterAndStateAndResult';
  tripFilter: TripFilter;
  tripFilterResult: TripFilterResult;
  tripFilterState: TripFilterState;
};

export type TripFilterElement = {
  __typename?: 'TripFilterElement';
  currencySymbol?: Maybe<Scalars['String']>;
  footnote?: Maybe<Scalars['String']>;
  hasToMatchAllOptions: Scalars['Boolean'];
  inputType: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  label: Scalars['String'];
  order: Scalars['Int'];
  tripFilterElementOptions: Array<Maybe<TripFilterElementOption>>;
  uniqueUrlKey: Scalars['String'];
};

export type TripFilterElementInput = {
  currencySymbol?: InputMaybe<Scalars['String']>;
  footnote?: InputMaybe<Scalars['String']>;
  hasToMatchAllOptions: Scalars['Boolean'];
  inputType: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  label: Scalars['String'];
  order: Scalars['Int'];
  tripFilterElementOptions: Array<InputMaybe<TripFilterElementOptionInput>>;
  uniqueUrlKey: Scalars['String'];
};

export type TripFilterElementOption = {
  __typename?: 'TripFilterElementOption';
  hasResults?: Maybe<Scalars['Boolean']>;
  imageChoice?: Maybe<ImageChoice>;
  isSelected?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  uniqueUrlKey: Scalars['String'];
};

export type TripFilterElementOptionInput = {
  hasResults?: InputMaybe<Scalars['Boolean']>;
  imageChoice?: InputMaybe<ImageChoiceInput>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  uniqueUrlKey: Scalars['String'];
};

export type TripFilterInput = {
  isShown?: InputMaybe<Scalars['Boolean']>;
  tripFilterElements: Array<TripFilterElementInput>;
};

export type TripFilterResult = {
  __typename?: 'TripFilterResult';
  agents?: Maybe<Array<Maybe<Agent>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  matchingTripsForCurrentPage: Array<Maybe<Trip>>;
  nextOffset?: Maybe<Scalars['Int']>;
  unmatchingTripsForCurrentPage: Array<Maybe<Trip>>;
};

export type TripFilterState = {
  __typename?: 'TripFilterState';
  filters: Scalars['Json'];
};

export type TripFilterStateInput = {
  filters: Scalars['Json'];
};

export type TripOfferingType = {
  __typename?: 'TripOfferingType';
  isOfferedByPublishedOwningAgent: Scalars['Boolean'];
};

export type TripPriceMatrix = {
  __typename?: 'TripPriceMatrix';
  hasMatrix?: Maybe<Scalars['Float']>;
  hasPricesFor2Pax?: Maybe<Scalars['Boolean']>;
  hasPricesFor4Pax?: Maybe<Scalars['Boolean']>;
  hasPricesFor6Pax?: Maybe<Scalars['Boolean']>;
  hasPricesForComfort?: Maybe<Scalars['Boolean']>;
  hasPricesForLuxury?: Maybe<Scalars['Boolean']>;
  hasPricesForStandard?: Maybe<Scalars['Boolean']>;
  priceFor2PaxComfort?: Maybe<Scalars['Float']>;
  priceFor2PaxLuxury?: Maybe<Scalars['Float']>;
  priceFor2PaxStandard?: Maybe<Scalars['Float']>;
  priceFor4PaxComfort?: Maybe<Scalars['Float']>;
  priceFor4PaxLuxury?: Maybe<Scalars['Float']>;
  priceFor4PaxStandard?: Maybe<Scalars['Float']>;
  priceFor6PaxComfort?: Maybe<Scalars['Float']>;
  priceFor6PaxLuxury?: Maybe<Scalars['Float']>;
  priceFor6PaxStandard?: Maybe<Scalars['Float']>;
  relevantMinPrice?: Maybe<Scalars['Float']>;
  targetCurrency?: Maybe<Currency>;
};

/** In our DB model TripRequest is main entity that contain request data. It has fields  that are mapped to DB table columns, e.g. created or originCountry and these created  dynamically or not mapped directly, e.g. title, shortDescription. */
export type TripRequest = {
  __typename?: 'TripRequest';
  /** Agent assigned to trip request. */
  agent?: Maybe<Agent>;
  country: Country;
  /** Country landing page header photo (if request is country specific). */
  countryLandingPageHeaderPhoto?: Maybe<Scalars['String']>;
  countryProfile: CountryProfile;
  created: Scalars['DateTime'];
  /** Trip main photo (if request is trip specific) or country landing page header photo (if request is country specific). */
  defaultPicture?: Maybe<Scalars['String']>;
  /** Current url path with GET params. */
  formUrlPath?: Maybe<Scalars['String']>;
  /** This has been introduced August 2019 in order to see a difference in user's intention  depending on the button they click on a trip page. */
  hasBookingIntention?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  /** If true that means trip request was rejected and not assigned to an agent. */
  isMarkedAsApprovedFake?: Maybe<Scalars['Boolean']>;
  isNewsletterSubscriptionClicked?: Maybe<Scalars['Boolean']>;
  isTermsAndConditionsAccepted?: Maybe<Scalars['Boolean']>;
  /** Check for the latest attachment that has been a pdf attachment. */
  itineraryLink?: Maybe<Scalars['String']>;
  /** Request locale object. */
  locale: Locale;
  /** Message left by customer when completing trip request form. */
  message?: Maybe<Scalars['String']>;
  /** Value entered by LTO/Account manager (if this was the case) or number of adults, children  and infants selected when completing trip request form. */
  numberOfPeopleTraveling?: Maybe<Scalars['String']>;
  /** Requester country name. */
  originCountry?: Maybe<Scalars['String']>;
  /** First confirmed booking payment link */
  paymentLink?: Maybe<Scalars['String']>;
  /** First confirmed booking total price (if trip request has confirmed booking) or min and  max prices selected when completing trip request form. */
  plannedOrBookingBudget?: Maybe<Array<Maybe<Money>>>;
  /** Number of travel days from first confirmed trip booking (if trip request has confirmed booking) or trip length selected when completing trip request form. */
  plannedOrBookingDuration?: Maybe<Scalars['Int']>;
  /** First confirmed booking end date (if trip request has confirmed booking) or approximate  arrival date + trip length selected when completing trip request form */
  plannedOrBookingEndDate?: Maybe<Scalars['String']>;
  /** First confirmed booking start date (if trip request has confirmed booking) or approximate  arrival date selected when completing trip request form. */
  plannedOrBookingStartDate?: Maybe<Scalars['String']>;
  /** Various translated texts that are displayed on the web. */
  relevantDynamicTexts?: Maybe<Array<Maybe<DynamicText>>>;
  /** Object that contain request data e.g. age range, country regions. */
  requestConfiguration?: Maybe<RequestConfiguration>;
  requester?: Maybe<Requester>;
  /** Requester country object. */
  requesterCountry?: Maybe<Country>;
  /** Generated when trip request is created and then used for security checks. */
  securityToken?: Maybe<Scalars['String']>;
  /** Trip meta description (if request is trip specific) or country landing page short  intro box (if request is country specific). */
  shortDescription?: Maybe<Scalars['String']>;
  /** Site 3 url to which customer is redirected after submitting the last step of a trip request form  and successful connection with the agent. In case customer is not connected to the agent,  site2 thanks page (that has rejection page content) is displayed. */
  site3ThanksPageUrl?: Maybe<Scalars['String']>;
  /** Trip title (if request is trip specific) or country name in format 'Trip to COUNTRY_NAME' (if request is country specific). */
  title?: Maybe<Scalars['String']>;
  /** Trip related to trip request (if request is trip specific). */
  trip?: Maybe<Trip>;
  /** Trip bookings created from this trip request. */
  tripBookings?: Maybe<Array<Maybe<TripBooking>>>;
  /** Completed trip request form type. */
  tripRequestFormType?: Maybe<TripRequestFormType>;
  /** Object storing information on the conversation between the customer and the agent. */
  tripRequestMessageThread?: Maybe<TripRequestMessageThread>;
  /** Current status of trip request. */
  tripRequestStatus?: Maybe<TripRequestStatus>;
  /** False if is detected as instant rejection request or bad quality request. Set during createTripRequest mutation. */
  wasInitiallyInterpretedAsQualityRequest?: Maybe<Scalars['Boolean']>;
};

export type TripRequestForm = {
  __typename?: 'TripRequestForm';
  /** Multiple choice accommodation level options same for all trip requests, e.g. Standard, Comfort, Luxury. */
  accLevelChoiceGroup?: Maybe<ImageChoiceGroup>;
  /** Single choice age range options same for all trip requests, e.g. 24 years or below, 25-34 years, ..., 65 years or above. */
  ageRanges?: Maybe<Array<Maybe<DropdownOption>>>;
  /** Single choice brand awareness source options same for all trip requests, e.g. Television, Social media. */
  brandAwarenessSources?: Maybe<Array<Maybe<DropdownOption>>>;
  /** Multiple choice country region options specific to trip request, e.g. Red Sea, Western Desert, Nile River. */
  countryRegionChoiceGroup?: Maybe<ImageChoiceGroup>;
  isNewsletterCheckboxShown?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED! */
  isPossibleToOfferInternationalFlights?: Maybe<Scalars['Boolean']>;
  /** Travellers feedback searched by tripRequest locale, country and trip. */
  reviews?: Maybe<Array<Maybe<TripBookingFeedback>>>;
  /** Multiple choice travel experience same for all trip requests, e.g. Luxury travel, Cultural visits. */
  travelExperienceChoiceGroup?: Maybe<ImageChoiceGroup>;
  /** Single choice travel style options same for all trip requests, e.g. Self-driving, Self-organized. */
  travelStyleChoiceGroup?: Maybe<ImageChoiceGroup>;
  tripRequest?: Maybe<TripRequest>;
};

export type TripRequestFormType = {
  __typename?: 'TripRequestFormType';
  id: Scalars['ID'];
  /** e.g. 3-step RQ form, 1-step RQ form */
  name?: Maybe<Scalars['String']>;
};

export type TripRequestMailMessageAttachment = {
  __typename?: 'TripRequestMailMessageAttachment';
  id: Scalars['ID'];
  isImage: Scalars['Boolean'];
  isPdf: Scalars['Boolean'];
  originalFilename: Scalars['String'];
  url: Scalars['String'];
};

export type TripRequestMessage = {
  __typename?: 'TripRequestMessage';
  attachments?: Maybe<Array<Maybe<TripRequestMailMessageAttachment>>>;
  contentHtml?: Maybe<Scalars['String']>;
  contentPlain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDraft?: Maybe<Scalars['Boolean']>;
  isFromAgent: Scalars['Boolean'];
  isFromClient: Scalars['Boolean'];
  isFromSystem: Scalars['Boolean'];
  isRead?: Maybe<Scalars['Boolean']>;
  isToAgent: Scalars['Boolean'];
  isToClient: Scalars['Boolean'];
  relevantSortingDateTime: Scalars['DateTime'];
  subject?: Maybe<Scalars['String']>;
  tripRequestMessageThread?: Maybe<TripRequestMessageThread>;
};

export type TripRequestMessageThread = {
  __typename?: 'TripRequestMessageThread';
  id: Scalars['ID'];
  initialMessageHtml?: Maybe<Scalars['String']>;
  lastActivityDateTime?: Maybe<Scalars['DateTime']>;
  tripRequest?: Maybe<TripRequest>;
};

export type TripRequestStatus = {
  __typename?: 'TripRequestStatus';
  id: Scalars['ID'];
  /** e.g. Trip Request created, Closed w/o booking, Closed with booking */
  name?: Maybe<Scalars['String']>;
};

export type TripTag = {
  __typename?: 'TripTag';
  /** Translated value e.g. This tour takes steps to positively impact the local community. */
  description?: Maybe<Scalars['String']>;
  /** E.g. fa-compass, fa-pagelines. */
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Translated value e.g. Designed for Families, Adventure. */
  name?: Maybe<Scalars['String']>;
  tripTagCategory?: Maybe<TripTagCategory>;
};

export type TripTagCategory = {
  __typename?: 'TripTagCategory';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type TripType = {
  __typename?: 'TripType';
  /** E.g. fa-compass, fa-pagelines. */
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Translated value e.g. Private Tour, Group Trip. */
  name?: Maybe<Scalars['String']>;
};

export type TrustpilotConfigResult = {
  __typename?: 'TrustpilotConfigResult';
  test: Scalars['String'];
};

export type TrustpilotReviewSummary = {
  __typename?: 'TrustpilotReviewSummary';
  numberOfFiveStars: Scalars['Int'];
  numberOfFourStars: Scalars['Int'];
  numberOfOneStars: Scalars['Int'];
  numberOfThreeStars: Scalars['Int'];
  numberOfTwoStars: Scalars['Int'];
  totalReviews: Scalars['Int'];
};

export type UpdateClientInput = {
  isAllowingToBeContacted?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UpdateUserInput>;
};

export type UpdateUserInput = {
  calendarLink?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['FileUpload']>;
  preferredLocale?: InputMaybe<Scalars['ID']>;
  publicName?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  calendarLink?: Maybe<Scalars['String']>;
  communityUser?: Maybe<CommunityUser>;
  countryCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstAndAbbreviatedLast?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFemale?: Maybe<Scalars['Boolean']>;
  isMale?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Photo>;
  photoURL?: Maybe<Scalars['String']>;
  preferredLocale?: Maybe<Locale>;
  publicName?: Maybe<Scalars['String']>;
};

export type WeightedTrip = {
  __typename?: 'WeightedTrip';
  trip: Trip;
  weight: Scalars['Float'];
};

export type WhatNextConfigResult = {
  __typename?: 'WhatNextConfigResult';
  test: Scalars['String'];
};

export type CompleteRequestFormStepMutationVariables = Exact<{
  formUuid: Scalars['String'];
  stepUuid: Scalars['String'];
  completedInputs: Array<InputMaybe<FormStepInputCompletionParams>> | InputMaybe<FormStepInputCompletionParams>;
}>;


export type CompleteRequestFormStepMutation = { __typename?: 'MutationPublic', completeRequestFormStep: { __typename?: 'FormStepCompletionResult', nextStepUuid?: string | null, formUuid: string, tripRequest?: { __typename?: 'FormTripRequestCreationResult', id: number, token: string, destinationCountryInternalKey: string, originCountryName?: string | null, user: { __typename?: 'FormUserCreationResult', id: number, email: string } } | null } };

export type CreateOrUpdateInternalTripRequestMessageInputMutationVariables = Exact<{
  tripRequestId: Scalars['ID'];
  securityToken: Scalars['String'];
  message: Scalars['String'];
}>;


export type CreateOrUpdateInternalTripRequestMessageInputMutation = { __typename?: 'MutationPublic', result: { __typename?: 'TripRequestMessage', id: string, contentPlain?: string | null } };

export type DoCommunityUserIdAndResetPasswordTokenMatchQueryVariables = Exact<{
  communityUserId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type DoCommunityUserIdAndResetPasswordTokenMatchQuery = { __typename?: 'QueryPublic', result: boolean };

export type GetAgentsByCountrySlugQueryVariables = Exact<{
  countrySlug: Scalars['String'];
}>;


export type GetAgentsByCountrySlugQuery = { __typename?: 'QueryPublic', getAgentsByCountrySlug?: Array<{ __typename?: 'Agent', publicName?: string | null, user?: { __typename?: 'User', photoURL?: string | null } | null } | null> | null };

export type GetContinentsWithPublishedTripsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContinentsWithPublishedTripsQuery = { __typename?: 'QueryPublic', continents?: Array<{ __typename?: 'Continent', name: string, countries?: Array<{ __typename?: 'Country', id: string, name: string, slug: string, internalKey: string, href?: string | null, continent?: { __typename?: 'Continent', name: string, internalKey: string } | null, countryProfileForRequestLocale?: { __typename?: 'CountryProfile', publishedAgents?: Array<{ __typename?: 'Agent', user?: { __typename?: 'User', publicName?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null } | null> | null } | null } | null> | null } | null> | null };

export type GetCountryBySlugQueryVariables = Exact<{
  countrySlug: Scalars['String'];
}>;


export type GetCountryBySlugQuery = { __typename?: 'QueryPublic', result: { __typename?: 'Country', name: string, internalKey: string, code: string, tripBookingTrustpilotReviewSummaryForCountry?: Array<{ __typename?: 'LocaleTrustpilotReviewSummary', locale: string, summary: { __typename?: 'TrustpilotReviewSummary', totalReviews: number, numberOfFiveStars: number, numberOfFourStars: number } } | null> | null } };

export type GetFiltersByCountrySlugQueryVariables = Exact<{
  countrySlug: Scalars['String'];
}>;


export type GetFiltersByCountrySlugQuery = { __typename?: 'QueryPublic', result?: { __typename?: 'TripFilter', tripFilterElements: Array<{ __typename?: 'TripFilterElement', uniqueUrlKey: string, isMultiple: boolean, hasToMatchAllOptions: boolean, currencySymbol?: string | null, label: string, order: number, inputType: string, footnote?: string | null, tripFilterElementOptions: Array<{ __typename?: 'TripFilterElementOption', uniqueUrlKey: string, label?: string | null, hasResults?: boolean | null, isSelected?: boolean | null, imageChoice?: { __typename?: 'ImageChoice', name: string, internalKey: string, imageUrl: string, description?: string | null } | null } | null> }> } | null };

export type GetLandingPageByPathQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type GetLandingPageByPathQuery = { __typename?: 'QueryPublic', result?: { __typename?: 'LandingPage', id: string, mainKeyword?: string | null, cachedFinalUrl?: string | null, requestFormPath?: string | null, headerPhotoImgAltText?: string | null, headerPhoto?: { __typename?: 'Photo', filename: string } | null } | null };

export type GetLanguageSwitcherPagesQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type GetLanguageSwitcherPagesQuery = { __typename?: 'QueryPublic', result?: Array<{ __typename?: 'LanguageSwitcherPage', url?: string | null, locale?: string | null } | null> | null };

export type GetPriceQueryVariables = Exact<{
  numberOfTravelers: Scalars['Int'];
  tripLength: Scalars['Int'];
  countrySlug: Scalars['String'];
}>;


export type GetPriceQuery = { __typename?: 'QueryPublic', getPriceRange: string };

export type GetRequestFormStepQueryVariables = Exact<{
  formUuid: Scalars['String'];
  stepUuid: Scalars['String'];
}>;


export type GetRequestFormStepQuery = { __typename?: 'QueryPublic', getRequestFormStep: { __typename?: 'FormStepConfigResult', currentStepUuid: string, previousStepUuid?: string | null, formUuid: string, totalStepsNumber: number, currentStepNumber: number, elements?: Array<{ __typename?: 'FormStepElementConfigResult', elementType: string, style?: { __typename?: 'ElementStyleConfigResult', paddingBottom?: { __typename?: 'PaddingBottomStyleConfigResult', value: number } | null, paddingTop?: { __typename?: 'PaddingTopStyleConfigResult', value: number } | null } | null, config?: { __typename?: 'ButtonsBarConfigResult', displayPreviousStep: boolean, displayNextStep: boolean, previousStepLabel?: string | null, previousStepIcon?: string | null, nextStepLabel?: string | null, nextStepIcon?: string | null } | { __typename?: 'HeaderConfigResult', variant: string, text: string } | { __typename?: 'InputConfigResult', inputUuid: string, inputType: string, completionType: string, completedJsonData?: any | null, inputConfig?: { __typename?: 'CheckboxInputConfigResult', label?: string | null, isRequired: boolean } | { __typename?: 'CounterInputConfigResult', minValue: number, maxValue: number, title: string, description: string, defaultValue: number } | { __typename?: 'DateInputConfigResult', label?: string | null, displayNullableCheckbox: boolean, nullableCheckboxLabel?: string | null, initialUnavailableWeeks: number, placeholder: string } | { __typename?: 'MultiselectInputConfigResult', items?: Array<{ __typename?: 'MultiselectInputItemConfigResult', itemId: number, title: string, imageUrl: string, label?: string | null, description?: string | null } | null> | null } | { __typename?: 'SelectInputConfigResult', items?: Array<{ __typename?: 'MultiselectInputItemConfigResult', itemId: number, title: string, label?: string | null, description?: string | null } | null> | null } | { __typename?: 'SliderInputConfigResult', minValue: number, minValueLabel: string, maxValue: number, maxValueLabel: string, defaultValue: number, defaultValueLabel: string, currentValueIcon: string, currentValueLabel: string, displayNullableCheckbox: boolean, nullableCheckboxLabel?: string | null } | { __typename?: 'TextInputConfigResult', label?: string | null, isRequired: boolean } | { __typename?: 'TextareaInputConfigResult', placeholderListTitle: string, placeholderListItems?: Array<{ __typename?: 'TextareaPlaceholderListInputItemConfigResult', title: string } | null> | null } | null } | { __typename?: 'LeCustomerConnectionConfigResult' } | { __typename?: 'LeProTipConfigResult', title: string, imagesPosition: string, description?: string | null, label?: string | null, agentsImages?: Array<{ __typename?: 'LeProTipAgentImageConfigResult', imageUrl: string } | null> | null } | { __typename?: 'PriceAndServicesConfigResult', priceRange: string, numberOfTravelers: number, tripLength: number } | { __typename?: 'ProgressBarConfigResult', completedPercentage: number, label?: string | null } | { __typename?: 'ProgressFeedbackConfigResult', label?: string | null, icon?: string | null } | { __typename?: 'TrustpilotConfigResult' } | { __typename?: 'WhatNextConfigResult' } | null } | null> | null } };

export type GetTripByPathQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type GetTripByPathQuery = { __typename?: 'QueryPublic', result?: { __typename?: 'Trip', id: string, title?: string | null, mapUrl?: string | null, description?: string | null, isGroupTrip?: boolean | null, amountOfTripDays?: number | null, mainPhotoURL?: string | null, linkToThreeStepRequestForm?: string | null, tripPriceMatrix?: { __typename?: 'TripPriceMatrix', relevantMinPrice?: number | null, targetCurrency?: { __typename?: 'Currency', abbreviation: string, symbol: string } | null } | null } | null };

export type GetTripFilterAndStateAndResultByLandingPageAndPathQueryVariables = Exact<{
  landingPageId: Scalars['ID'];
  path: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTripFilterAndStateAndResultByLandingPageAndPathQuery = { __typename?: 'QueryPublic', result?: { __typename?: 'TripFilterAndStateAndResult', tripFilter: { __typename?: 'TripFilter', isShown?: boolean | null, tripFilterElements: Array<{ __typename?: 'TripFilterElement', uniqueUrlKey: string, isMultiple: boolean, hasToMatchAllOptions: boolean, currencySymbol?: string | null, label: string, order: number, inputType: string, footnote?: string | null, tripFilterElementOptions: Array<{ __typename?: 'TripFilterElementOption', uniqueUrlKey: string, label?: string | null, hasResults?: boolean | null, isSelected?: boolean | null, imageChoice?: { __typename?: 'ImageChoice', name: string, internalKey: string, imageUrl: string, description?: string | null } | null } | null> }> }, tripFilterState: { __typename?: 'TripFilterState', filters: any } } | null };

export type GetTripFilterResultByLandingPageAndTripFilterAndStateQueryVariables = Exact<{
  landingPageId: Scalars['ID'];
  tripFilter: TripFilterInput;
  tripFilterState: TripFilterStateInput;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTripFilterResultByLandingPageAndTripFilterAndStateQuery = { __typename?: 'QueryPublic', result?: { __typename?: 'TripFilterResult', nextOffset?: number | null, hasNextPage?: boolean | null, agents?: Array<{ __typename?: 'Agent', id: string, profilePath?: string | null, avgRating?: number | null, isAgencyOptedInForFlexTerms?: boolean | null, user?: { __typename?: 'User', publicName?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null, mainCountry?: { __typename?: 'Country', name: string } | null } | null> | null, matchingTripsForCurrentPage: Array<{ __typename?: 'Trip', id: string, title?: string | null, mainPhotoURL?: string | null, tripPath?: string | null, linkToThreeStepRequestForm?: string | null, amountOfTripDays?: number | null, startingPricePerPerson?: number | null, isNewTrip?: boolean | null, isGroupTrip?: boolean | null, isModuleTrip?: boolean | null, mainAttractions?: Array<string | null> | null, initialMainCountry: { __typename?: 'Country', name: string }, currency?: { __typename?: 'Currency', symbol: string, abbreviation: string } | null, mainTripTag?: { __typename?: 'TripTag', id: string, name?: string | null, iconName?: string | null } | null, sustainabilityTripTags?: Array<{ __typename?: 'TripTag', id: string, name?: string | null, iconName?: string | null, description?: string | null } | null> | null, agent?: { __typename?: 'Agent', isAgencyOptedInForFlexTerms?: boolean | null, avgRating?: number | null, user?: { __typename?: 'User', publicName?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null } | null } | null>, unmatchingTripsForCurrentPage: Array<{ __typename?: 'Trip', id: string, title?: string | null, mainPhotoURL?: string | null, tripPath?: string | null, linkToThreeStepRequestForm?: string | null, amountOfTripDays?: number | null, startingPricePerPerson?: number | null, isNewTrip?: boolean | null, isGroupTrip?: boolean | null, isModuleTrip?: boolean | null, mainAttractions?: Array<string | null> | null, initialMainCountry: { __typename?: 'Country', name: string }, currency?: { __typename?: 'Currency', symbol: string, abbreviation: string } | null, mainTripTag?: { __typename?: 'TripTag', id: string, name?: string | null, iconName?: string | null } | null, sustainabilityTripTags?: Array<{ __typename?: 'TripTag', id: string, name?: string | null, iconName?: string | null, description?: string | null } | null> | null, agent?: { __typename?: 'Agent', isAgencyOptedInForFlexTerms?: boolean | null, avgRating?: number | null, user?: { __typename?: 'User', publicName?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null } | null } | null> } | null };

export type GetTripRequestByIdAndTemporaryTokenQueryVariables = Exact<{
  tripRequestId: Scalars['ID'];
  securityToken: Scalars['String'];
}>;


export type GetTripRequestByIdAndTemporaryTokenQuery = { __typename?: 'QueryPublic', result: { __typename?: 'TripRequest', countryLandingPageHeaderPhoto?: string | null, requesterCountry?: { __typename?: 'Country', code: string } | null, country: { __typename?: 'Country', slug: string, name: string, internalKey: string }, agent?: { __typename?: 'Agent', publicName?: string | null, user?: { __typename?: 'User', calendarLink?: string | null, photo?: { __typename?: 'Photo', filename: string } | null, communityUser?: { __typename?: 'CommunityUser', description?: string | null } | null } | null } | null, requester?: { __typename?: 'Requester', user?: { __typename?: 'User', email?: string | null, firstName?: string | null, phone?: string | null, countryCode?: string | null, photo?: { __typename?: 'Photo', filename: string } | null, communityUser?: { __typename?: 'CommunityUser', id: string } | null } | null } | null } };

export type GetTripsByCountrySlugAndFiltersQueryVariables = Exact<{
  countrySlug: Scalars['String'];
  filters: Scalars['Json'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetTripsByCountrySlugAndFiltersQuery = { __typename?: 'QueryPublic', result?: { __typename?: 'TripFilterResult', nextOffset?: number | null, hasNextPage?: boolean | null, matchingTripsForCurrentPage: Array<{ __typename?: 'Trip', id: string, title?: string | null, mainPhotoURL?: string | null, tripPath?: string | null, linkToThreeStepRequestForm?: string | null, amountOfTripDays?: number | null, startingPricePerPerson?: number | null, isNewTrip?: boolean | null, isGroupTrip?: boolean | null, isModuleTrip?: boolean | null, mainAttractions?: Array<string | null> | null, initialMainCountry: { __typename?: 'Country', name: string }, currency?: { __typename?: 'Currency', symbol: string, abbreviation: string } | null, mainTripTag?: { __typename?: 'TripTag', id: string, name?: string | null, iconName?: string | null } | null, sustainabilityTripTags?: Array<{ __typename?: 'TripTag', id: string, name?: string | null, iconName?: string | null, description?: string | null } | null> | null, agent?: { __typename?: 'Agent', isAgencyOptedInForFlexTerms?: boolean | null, avgRating?: number | null, user?: { __typename?: 'User', publicName?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null } | null } | null>, agents?: Array<{ __typename?: 'Agent', id: string, profilePath?: string | null, avgRating?: number | null, isAgencyOptedInForFlexTerms?: boolean | null, user?: { __typename?: 'User', publicName?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null, mainCountry?: { __typename?: 'Country', name: string } | null } | null> | null } | null };

export type GetUserByIdAndTokenQueryVariables = Exact<{
  userId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type GetUserByIdAndTokenQuery = { __typename?: 'QueryPublic', result: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, preferredLocale?: { __typename?: 'Locale', id: string, name: string, primaryLanguage?: { __typename?: 'Language', id: string, name: string, code: string } | null } | null, photo?: { __typename?: 'Photo', filename: string } | null } };

export type InitRequestFormMutationVariables = Exact<{
  countrySlug: Scalars['String'];
  metadata: RequestFormMetadataParams;
}>;


export type InitRequestFormMutation = { __typename?: 'MutationPublic', initRequestForm: { __typename?: 'RequestFormInitializationResult', formUuid: string, firstStepUuid: string } };

export type RegisterAndVerifyByUserIdAndTokenMutationVariables = Exact<{
  userId: Scalars['ID'];
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type RegisterAndVerifyByUserIdAndTokenMutation = { __typename?: 'MutationPublic', result?: { __typename?: 'CommunityUser', id: string, originalRequestUri?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, photo?: { __typename?: 'Photo', filename: string } | null, preferredLocale?: { __typename?: 'Locale', id: string, name: string, primaryLanguage?: { __typename?: 'Language', id: string, name: string, code: string } | null } | null } } | null };

export type ResetPasswordByCommunityUserIdAndTokenMutationVariables = Exact<{
  communityUserId: Scalars['ID'];
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordByCommunityUserIdAndTokenMutation = { __typename?: 'MutationPublic', result: boolean };

export type UpdateTripRequestUserByIdAndTokenMutationVariables = Exact<{
  tripRequestId: Scalars['ID'];
  securityToken: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTripRequestUserByIdAndTokenMutation = { __typename?: 'MutationPublic', result: { __typename?: 'TripRequest', requester?: { __typename?: 'Requester', user?: { __typename?: 'User', email?: string | null, firstName?: string | null, phone?: string | null, countryCode?: string | null, photo?: { __typename?: 'Photo', filename: string } | null } | null } | null } };


export const CompleteRequestFormStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteRequestFormStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stepUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormStepInputCompletionParams"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeRequestFormStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formUuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stepUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stepUuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedInputs"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextStepUuid"}},{"kind":"Field","name":{"kind":"Name","value":"formUuid"}},{"kind":"Field","name":{"kind":"Name","value":"tripRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"destinationCountryInternalKey"}},{"kind":"Field","name":{"kind":"Name","value":"originCountryName"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompleteRequestFormStepMutation, CompleteRequestFormStepMutationVariables>;
export const CreateOrUpdateInternalTripRequestMessageInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrUpdateInternalTripRequestMessageInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tripRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"securityToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"createInternalTripRequestMessageByTripRequestAndSend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tripRequestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tripRequestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"securityToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"securityToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentPlain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentPlain"}}]}}]}}]} as unknown as DocumentNode<CreateOrUpdateInternalTripRequestMessageInputMutation, CreateOrUpdateInternalTripRequestMessageInputMutationVariables>;
export const DoCommunityUserIdAndResetPasswordTokenMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DoCommunityUserIdAndResetPasswordTokenMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"communityUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"doCommunityUserIdAndResetPasswordTokenMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"communityUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"communityUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<DoCommunityUserIdAndResetPasswordTokenMatchQuery, DoCommunityUserIdAndResetPasswordTokenMatchQueryVariables>;
export const GetAgentsByCountrySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentsByCountrySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAgentsByCountrySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countrySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoURL"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentsByCountrySlugQuery, GetAgentsByCountrySlugQueryVariables>;
export const GetContinentsWithPublishedTripsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContinentsWithPublishedTrips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"continents"},"name":{"kind":"Name","value":"getContinentsWithPublishedTrips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"countries"},"name":{"kind":"Name","value":"countriesWithPublishedTrips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"href"},"name":{"kind":"Name","value":"linkToClp"}},{"kind":"Field","name":{"kind":"Name","value":"continent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryProfileForRequestLocale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalKey"}}]}}]}}]}}]} as unknown as DocumentNode<GetContinentsWithPublishedTripsQuery, GetContinentsWithPublishedTripsQueryVariables>;
export const GetCountryBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountryBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getCountryBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalKey"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"tripBookingTrustpilotReviewSummaryForCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalReviews"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfFiveStars"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfFourStars"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCountryBySlugQuery, GetCountryBySlugQueryVariables>;
export const GetFiltersByCountrySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFiltersByCountrySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getFiltersByCountrySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countrySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripFilterElements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueUrlKey"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"hasToMatchAllOptions"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"inputType"}},{"kind":"Field","name":{"kind":"Name","value":"tripFilterElementOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueUrlKey"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"imageChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalKey"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasResults"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}}]}}]}}]}}]} as unknown as DocumentNode<GetFiltersByCountrySlugQuery, GetFiltersByCountrySlugQueryVariables>;
export const GetLandingPageByPathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLandingPageByPath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getLandingPageByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mainKeyword"}},{"kind":"Field","name":{"kind":"Name","value":"cachedFinalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"requestFormPath"}},{"kind":"Field","name":{"kind":"Name","value":"headerPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerPhotoImgAltText"}}]}}]}}]} as unknown as DocumentNode<GetLandingPageByPathQuery, GetLandingPageByPathQueryVariables>;
export const GetLanguageSwitcherPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLanguageSwitcherPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getLanguageSwitcherPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locale"},"name":{"kind":"Name","value":"localeString"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetLanguageSwitcherPagesQuery, GetLanguageSwitcherPagesQueryVariables>;
export const GetPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfTravelers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tripLength"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPriceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"numberOfTravelers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfTravelers"}}},{"kind":"Argument","name":{"kind":"Name","value":"tripLength"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tripLength"}}},{"kind":"Argument","name":{"kind":"Name","value":"countrySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}}}]}]}}]} as unknown as DocumentNode<GetPriceQuery, GetPriceQueryVariables>;
export const GetRequestFormStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequestFormStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stepUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRequestFormStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formUuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stepUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stepUuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStepUuid"}},{"kind":"Field","name":{"kind":"Name","value":"previousStepUuid"}},{"kind":"Field","name":{"kind":"Name","value":"formUuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalStepsNumber"}},{"kind":"Field","name":{"kind":"Name","value":"currentStepNumber"}},{"kind":"Field","name":{"kind":"Name","value":"elements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elementType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paddingBottom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paddingTop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputUuid"}},{"kind":"Field","name":{"kind":"Name","value":"inputType"}},{"kind":"Field","name":{"kind":"Name","value":"completionType"}},{"kind":"Field","name":{"kind":"Name","value":"completedJsonData"}},{"kind":"Field","name":{"kind":"Name","value":"inputConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SliderInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"minValueLabel"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValueLabel"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValueLabel"}},{"kind":"Field","name":{"kind":"Name","value":"currentValueIcon"}},{"kind":"Field","name":{"kind":"Name","value":"currentValueLabel"}},{"kind":"Field","name":{"kind":"Name","value":"displayNullableCheckbox"}},{"kind":"Field","name":{"kind":"Name","value":"nullableCheckboxLabel"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DateInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"displayNullableCheckbox"}},{"kind":"Field","name":{"kind":"Name","value":"nullableCheckboxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"initialUnavailableWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CounterInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextareaInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholderListTitle"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderListItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckboxInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiselectInputConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgressFeedbackConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeaderConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgressBarConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LeProTipConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imagesPosition"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"agentsImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAndServicesConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfTravelers"}},{"kind":"Field","name":{"kind":"Name","value":"tripLength"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonsBarConfigResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayPreviousStep"}},{"kind":"Field","name":{"kind":"Name","value":"displayNextStep"}},{"kind":"Field","name":{"kind":"Name","value":"previousStepLabel"}},{"kind":"Field","name":{"kind":"Name","value":"previousStepIcon"}},{"kind":"Field","name":{"kind":"Name","value":"nextStepLabel"}},{"kind":"Field","name":{"kind":"Name","value":"nextStepIcon"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRequestFormStepQuery, GetRequestFormStepQueryVariables>;
export const GetTripByPathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTripByPath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getTripByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mapUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTrip"}},{"kind":"Field","name":{"kind":"Name","value":"amountOfTripDays"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhotoURL"}},{"kind":"Field","name":{"kind":"Name","value":"tripPriceMatrix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relevantMinPrice"}},{"kind":"Field","name":{"kind":"Name","value":"targetCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkToThreeStepRequestForm"}}]}}]}}]} as unknown as DocumentNode<GetTripByPathQuery, GetTripByPathQueryVariables>;
export const GetTripFilterAndStateAndResultByLandingPageAndPathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTripFilterAndStateAndResultByLandingPageAndPath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"landingPageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getTripFilterAndStateAndResultByLandingPageAndPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"landingPageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"landingPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripFilterElements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueUrlKey"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"hasToMatchAllOptions"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"inputType"}},{"kind":"Field","name":{"kind":"Name","value":"tripFilterElementOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueUrlKey"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"imageChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalKey"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasResults"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tripFilterState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filters"}}]}}]}}]}}]} as unknown as DocumentNode<GetTripFilterAndStateAndResultByLandingPageAndPathQuery, GetTripFilterAndStateAndResultByLandingPageAndPathQueryVariables>;
export const GetTripFilterResultByLandingPageAndTripFilterAndStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTripFilterResultByLandingPageAndTripFilterAndState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"landingPageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tripFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TripFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tripFilterState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TripFilterStateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getTripFilterResultByLandingPageAndTripFilterAndState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"landingPageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"landingPageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tripFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tripFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"tripFilterState"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tripFilterState"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePath"}},{"kind":"Field","name":{"kind":"Name","value":"avgRating"}},{"kind":"Field","name":{"kind":"Name","value":"isAgencyOptedInForFlexTerms"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingTripsForCurrentPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhotoURL"}},{"kind":"Field","name":{"kind":"Name","value":"initialMainCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tripPath"}},{"kind":"Field","name":{"kind":"Name","value":"linkToThreeStepRequestForm"}},{"kind":"Field","name":{"kind":"Name","value":"amountOfTripDays"}},{"kind":"Field","name":{"kind":"Name","value":"startingPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainTripTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityTripTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNewTrip"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTrip"}},{"kind":"Field","name":{"kind":"Name","value":"isModuleTrip"}},{"kind":"Field","name":{"kind":"Name","value":"mainAttractions"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAgencyOptedInForFlexTerms"}},{"kind":"Field","name":{"kind":"Name","value":"avgRating"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unmatchingTripsForCurrentPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhotoURL"}},{"kind":"Field","name":{"kind":"Name","value":"initialMainCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tripPath"}},{"kind":"Field","name":{"kind":"Name","value":"linkToThreeStepRequestForm"}},{"kind":"Field","name":{"kind":"Name","value":"amountOfTripDays"}},{"kind":"Field","name":{"kind":"Name","value":"startingPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainTripTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityTripTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNewTrip"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTrip"}},{"kind":"Field","name":{"kind":"Name","value":"isModuleTrip"}},{"kind":"Field","name":{"kind":"Name","value":"mainAttractions"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAgencyOptedInForFlexTerms"}},{"kind":"Field","name":{"kind":"Name","value":"avgRating"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextOffset"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]} as unknown as DocumentNode<GetTripFilterResultByLandingPageAndTripFilterAndStateQuery, GetTripFilterResultByLandingPageAndTripFilterAndStateQueryVariables>;
export const GetTripRequestByIdAndTemporaryTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTripRequestByIdAndTemporaryToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tripRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"securityToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getTripRequestByIdAndTemporaryToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tripRequestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tripRequestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"securityToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"securityToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requesterCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"communityUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calendarLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"communityUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryLandingPageHeaderPhoto"}}]}}]}}]} as unknown as DocumentNode<GetTripRequestByIdAndTemporaryTokenQuery, GetTripRequestByIdAndTemporaryTokenQueryVariables>;
export const GetTripsByCountrySlugAndFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTripsByCountrySlugAndFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getTripsByCountrySlugAndFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countrySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextOffset"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"matchingTripsForCurrentPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhotoURL"}},{"kind":"Field","name":{"kind":"Name","value":"initialMainCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tripPath"}},{"kind":"Field","name":{"kind":"Name","value":"linkToThreeStepRequestForm"}},{"kind":"Field","name":{"kind":"Name","value":"amountOfTripDays"}},{"kind":"Field","name":{"kind":"Name","value":"startingPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainTripTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityTripTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNewTrip"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTrip"}},{"kind":"Field","name":{"kind":"Name","value":"isModuleTrip"}},{"kind":"Field","name":{"kind":"Name","value":"mainAttractions"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAgencyOptedInForFlexTerms"}},{"kind":"Field","name":{"kind":"Name","value":"avgRating"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePath"}},{"kind":"Field","name":{"kind":"Name","value":"avgRating"}},{"kind":"Field","name":{"kind":"Name","value":"isAgencyOptedInForFlexTerms"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTripsByCountrySlugAndFiltersQuery, GetTripsByCountrySlugAndFiltersQueryVariables>;
export const GetUserByIdAndTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserByIdAndToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"getUserByIdAndToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdAndTokenQuery, GetUserByIdAndTokenQueryVariables>;
export const InitRequestFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitRequestForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestFormMetadataParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initRequestForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"countrySlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrySlug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formUuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstStepUuid"}}]}}]}}]} as unknown as DocumentNode<InitRequestFormMutation, InitRequestFormMutationVariables>;
export const RegisterAndVerifyByUserIdAndTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterAndVerifyByUserIdAndToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"registerAndVerifyByUserIdAndToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"originalRequestUri"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegisterAndVerifyByUserIdAndTokenMutation, RegisterAndVerifyByUserIdAndTokenMutationVariables>;
export const ResetPasswordByCommunityUserIdAndTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPasswordByCommunityUserIdAndToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"communityUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"resetPasswordByCommunityUserIdAndToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"communityUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"communityUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordByCommunityUserIdAndTokenMutation, ResetPasswordByCommunityUserIdAndTokenMutationVariables>;
export const UpdateTripRequestUserByIdAndTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTripRequestUserByIdAndToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tripRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"securityToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"updateTripRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tripRequestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tripRequestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"securityToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"securityToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"tripRequest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requester"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTripRequestUserByIdAndTokenMutation, UpdateTripRequestUserByIdAndTokenMutationVariables>;